import React from 'react'

function Contact() {
  return (
    <div id="contact" className="flex  justify-start items-center flex-col h-screen scroll-mt-20">
      <h2 className="text-6xl">Contact me</h2>
      <hr className="w-1/2 h-3 text-white my-8 " />
      <form action={process.env.REACT_APP_ACTION} method='POST' className='w-full flex justify-start items-center flex-col'>
        <input type="text" name='Full Name' placeholder='Full Name' className="w-3/5 h-8 m-4 p-2 rounded-md text-black md:w-1/2" required/>
      <input type="email" name="email" placeholder="Email" className="w-3/5 h-8 m-4 p-2 rounded-md text-black md:w-1/2" required/>
      <select name="Country" className="w-3/5 h-12 m-4 p-2 rounded-md text-black md:w-1/2">
        <option>Estados Unidos</option>
        <option>Mexico</option>
        <option>Colombia</option>
        <option>Peru</option>
        <option>Chile</option>
        <option>Argentina</option>
        <option>Canada</option>
        <option>Venezuela</option>
        <option>Guatemala</option>
        <option>Other</option>
      </select>
      <textarea name="Message" id="" cols="30" rows="10" placeholder='Message' className="w-3/5 h-1/5 m-4 rounded-md text-black md:w-1/2 text-start p-2"></textarea>     
      <button type="submit" className='cursor-pointer w-1/5 h-12 bg-green ease-in-out duration-300 hover:bg-green3 rounded-md text-2xl'>Send</button>
      </form>
    </div>
  )
}

export default Contact
